import { render } from "./SomethingWentWrong.vue?vue&type=template&id=6dec62fe&scoped=true"
import script from "./SomethingWentWrong.vue?vue&type=script&lang=js"
export * from "./SomethingWentWrong.vue?vue&type=script&lang=js"

import "./SomethingWentWrong.vue?vue&type=style&index=0&id=6dec62fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dec62fe"]])

export default __exports__